module.exports = __webpack_public_path__ + "img/shenqing@2x.53ffc4ac.png";